export class forgotPasswordModel {
  username:any
}
